export default __webpack_public_path__ + "static/media/interac-white-logo.ce13e51b.png";